// /src/components/calendar/CalendarConnect.js
import { useState, useEffect } from "react";
import { useAuth } from "../../lib/AuthContext.js";
import { Calendar as CalIcon, CheckCircle, AlertCircle } from "lucide-react";

export default function CalendarConnect({ token }) {
  const { user } = useAuth();
  const isConnected = !!user?.google_calendar?.access_token;
  const [urlMsg, setUrlMsg] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("connected") === "true") {
      setUrlMsg({ ok: true, text: "Google Calendar connected successfully!" });
      window.history.replaceState({}, "", "/calendar");
    } else if (params.get("error")) {
      setUrlMsg({ ok: false, text: `Connection failed: ${params.get("error").replace(/_/g, " ")}` });
      window.history.replaceState({}, "", "/calendar");
    }
  }, []);

  const handleConnect = () => {
    window.location.href = `/api/gcalendarconnect?token=${encodeURIComponent(token)}`;
  };

  const handleDisconnect = async () => {
    if (!window.confirm("Disconnect Google Calendar?")) return;
    await fetch("/api/gcalendardisconnect", {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    });
    window.location.reload();
  };

  if (isConnected) {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "#64748b" }}>
          <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#22c55e", display: "inline-block", flexShrink: 0 }} />
          Google Calendar connected
          <button onClick={handleDisconnect}
            style={{ fontSize: 12, color: "#94a3b8", background: "none", border: "none", cursor: "pointer", textDecoration: "underline", padding: 0, marginLeft: 2 }}>
            Disconnect
          </button>
        </div>
        {urlMsg && <StatusBanner msg={urlMsg} />}
      </div>
    );
  }

  return (
    <div className="card" style={{ maxWidth: 480, textAlign: "center", padding: "48px 40px" }}>
      <CalIcon size={48} color="#cbd5e1" style={{ marginBottom: 16 }} />
      <h2 style={{ fontSize: 20, fontWeight: 700, color: "#0f172a", margin: "0 0 8px" }}>Connect Google Calendar</h2>
      <p style={{ color: "#64748b", fontSize: 14, marginBottom: 24 }}>
        Link your Google Calendar to view and create appointments directly from the CRM.
      </p>
      {urlMsg && <div style={{ marginBottom: 16 }}><StatusBanner msg={urlMsg} /></div>}
      <button className="btn btn-primary" onClick={handleConnect} style={{ gap: 8 }}>
        <CalIcon size={15} /> Connect Google Calendar
      </button>
    </div>
  );
}

function StatusBanner({ msg }) {
  return (
    <div style={{
      padding: "10px 14px", borderRadius: 8, fontSize: 13,
      display: "flex", alignItems: "center", gap: 8,
      background: msg.ok ? "#f0fdf4" : "#fef2f2",
      color: msg.ok ? "#16a34a" : "#dc2626",
      border: `1px solid ${msg.ok ? "#bbf7d0" : "#fecaca"}`,
    }}>
      {msg.ok ? <CheckCircle size={14} /> : <AlertCircle size={14} />}
      {msg.text}
    </div>
  );
}